import moment from 'moment';

// CONVERTER DATA PARA PT-BR COM HORA
export const convertDatePtBrHs = data => {
  if (!data) return null;
  return moment(data).format('DD/MM/YYYY HH:mm:ss', 'pt', true);
};

// CONVERTER DATA PARA PT-BR
export const convertDatePtBr = data => {
  if (!data) return null;
  return moment(data).format('DD/MM/YYYY', 'pt', true);
};

// CONVERTER DATA PARA DB
export const convertDate = data => {
  if (!data) return null;
  return moment(moment(data, 'DD/MM/YYYY')).format('YYYY-MM-DD', 'pt', true);
};

export const getNomeMes = (numeroMes, ano) => {
  const meses = [
    { valor: 1, descricao: `Janeiro - ${ano}` },
    { valor: 2, descricao: `Fevereiro - ${ano}` },
    { valor: 3, descricao: `Março - ${ano}` },
    { valor: 4, descricao: `Abril - ${ano}` },
    { valor: 5, descricao: `Maio - ${ano}` },
    { valor: 6, descricao: `Junho - ${ano}` },
    { valor: 7, descricao: `Julho - ${ano}` },
    { valor: 8, descricao: `Agosto - ${ano}` },
    { valor: 9, descricao: `Setembro - ${ano}` },
    { valor: 10, descricao: `Outubro - ${ano}` },
    { valor: 11, descricao: `Novembro - ${ano}` },
    { valor: 12, descricao: `Dezembro - ${ano}` },
  ];
  return meses?.find(x => x.valor === numeroMes)?.descricao;
};
